/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_User_Role_TitleInputs */

const en_admin_settings_groups_user_role_title = /** @type {(inputs: Admin_Settings_Groups_User_Role_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Roles`)
};

const zh_admin_settings_groups_user_role_title = /** @type {(inputs: Admin_Settings_Groups_User_Role_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户角色`)
};

/**
* | output |
* | --- |
* | "User Roles" |
*
* @param {Admin_Settings_Groups_User_Role_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_user_role_title = /** @type {((inputs?: Admin_Settings_Groups_User_Role_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_User_Role_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_user_role_title(inputs)
	return zh_admin_settings_groups_user_role_title(inputs)
});
export { admin_settings_groups_user_role_title as "admin.settings.groups.user_role.title" }